import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-paycard-detail',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {
  @Input() text: string;

  constructor(
    private activeModal: NgbActiveModal,
    private cd: ChangeDetectorRef
  ) {
    console.log('confirm modal');
  }

  onConfirm() {
    this.activeModal.close();
  }

  onCloseModal() {
    this.activeModal.dismiss();
  }
}
